import { ref, computed, onMounted } from "vue";
import { defineStore } from "pinia";
import axios from "axios";
import { API_URL } from "@/utils/constans.js";
import { useRoute } from "vue-router";

export const useSettingsStore = defineStore("settings", () => {
	const route = useRoute();

	const settings = ref({});
	const statusSurveyFuture = computed(() => settings.value.status === 'future');
	const statusSurveyEndStock = computed(() => settings.value.status === 'registration');
	const statusSurveyRegistration = computed(() => settings.value.status === 'registration');
	const statusSurveyModeration = computed(() => settings.value.status === 'moderation_survey');
	const statusSurveyExtra = computed(() => settings.value.status === 'extra_survey');
	const statusSurveyChoose = computed(() => settings.value.status === 'choose_finalists');
	const statusSurveyFinal = computed(() => settings.value.status === 'final');

	const loaderActive = ref(false);
	const isPageLoaded = ref(false);
	const widthWindow = ref(window.innerWidth);
	const heightWindow = ref(window.innerHeight);
	

	const mainSettings = async () => {
		try {
			const response = await axios.get(`${API_URL}/api/main/settings`);
			settings.value = response.data;
		} catch (error) {
			console.log("error:", error);
		}
	};

	const getFaq = async () => {
		try {
			const response = await axios.get(`${API_URL}/api/feedback/faq?limit=1000`);
			return response;
		} catch (error) {
			console.log("getFaq:", error);
		}
	};

	const updateWidthWindow = () => {
		widthWindow.value = window.innerWidth;
		heightWindow.value = window.innerHeight;
	};

	const pageLoaded = () => {
		setTimeout(() => (isPageLoaded.value = true), 1000);
	};


	onMounted(async () => {
		window.addEventListener("resize", updateWidthWindow);
		if (document.readyState === "complete") {
			pageLoaded();
		} else {
			window.onload = () => pageLoaded();
		}
	
	

	});

	return {
		mainSettings,
		getFaq,

		settings,
		loaderActive,
		widthWindow,
		heightWindow,
		statusSurveyFuture,
		statusSurveyEndStock,
		statusSurveyRegistration,
		statusSurveyModeration,
		statusSurveyExtra,
		statusSurveyChoose,
		statusSurveyFinal,
	};
});
